<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp; Ask an Expert
    <div class="export_csv">
      <button
        class="clear_button_export"
        (click)="openDialogexport()"
        style="float: right"
        mat-raised-button
        color="primary"
      >
        Export
      </button>
    </div>
  </div>
  <div class="page__content shadow p-3">
    <div>
      <br />
      <div>
        <table class="firstTable">
          <tr>
            <th class="FirstTh">Total tickets raised</th>
            <th class="FirstTh">Tickets raised this month</th>
            <!-- <th class="FirstTh">Average Rating</th> -->
          </tr>
          <tr style="height: 50px">
            <td class="FirstTd">{{ totalAskTicket.totalCount }}</td>
            <td class="FirstTd">
              {{ totalAskTicket.totalRequestRisedInADay }}
            </td>
          </tr>
        </table>
      </div>
      <mat-card>
        <div class="example-header" *ngIf="filtershow">
          <mat-form-field
            class="full-width-field"
            style="width: 50% !important"
          >
            <input
              matInput
              [(ngModel)]="searchData"
              (change)="changeFn($event)"
              placeholder="Search"
            /> </mat-form-field
          >&nbsp;
          <button
            type="submit"
            (click)="applyFilter()"
            class="btn btn-primary mat-primary search_bar"
          >
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>
          <hr />

          <mat-form-field>
            <!-- <label for="exampleInputEmail1">The range date</label> -->
            <input
              matInput
              type="text"
              name="daterange"
              placeholder="Date Range"
              [min]="minDate"
              [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }"
              autocomplete="off"
              [max]="maxDate"
              [alwaysShowCalendars]="true"
              ngxDaterangepickerMd
              [(ngModel)]="sharedate"
              [showCustomRangeLabel]="true"
              [ranges]="ranges"
              (change)="onDateRangeChanged(sharedate)"
            /> </mat-form-field
          >&nbsp;
          <mat-form-field (click)="suche()">
            <mat-select
              [formControl]="bankMultiCtrl"
              [(ngModel)]="statedata"
              ngDefaultControl
              placeholder="States"
              [multiple]="true"
              #multiSelect
              noEntriesFoundLabel="'no matching country found'"
            >
              <mat-option>
                <ngx-mat-select-search
                  id="search1"
                  [showToggleAllCheckbox]="true"
                  (ngModelChange)="filterMyOptions($event); notFound()"
                  [toggleAllCheckboxIndeterminate]="isIndeterminate"
                  [toggleAllCheckboxChecked]="isChecked"
                  (toggleAll)="toggleSelectAll($event)"
                  [formControl]="bankMultiFilterCtrl"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let bank of filteredBanksMulti | async"
                [value]="bank"
              >
                {{ bank.stateName }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <mat-form-field (click)="sucheDistrict()">
            <mat-select
              [formControl]="districtMultiCtrl"
              [(ngModel)]="districtdata"
              ngDefaultControl
              placeholder="Districts"
              [multiple]="true"
              #multiSelect
            >
              <mat-option>
                <ngx-mat-select-search
                  id="search1"
                  [showToggleAllCheckbox]="true"
                  [toggleAllCheckboxIndeterminate]="isIndeterminateDistrict"
                  [toggleAllCheckboxChecked]="isCheckedDistrict"
                  (toggleAll)="toggleSelectAlldistrict($event)"
                  [formControl]="districtMultiFilterCtrl"
                  (ngModelChange)="notFoundDistrict()"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let district of selectDistrict"
                [value]="district"
              >
                {{ district }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <!-- <mat-form-field>
              <mat-label>Duration</mat-label>
              <mat-date-range-input [formGroup]="form" [rangePicker]="picker">
                  <input matStartDate formControlName="start" placeholder="Start date">
                  <input (dateChange)="filterUserDetail(selectFilterData1, selectFilterData)" matEndDate
                      formControlName="end" placeholder="End date">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>&nbsp;&nbsp; -->

          <button
            type="submit"
            style="margin-top: 12px; margin-right: -3px"
            (click)="clearFilter()"
            class="btn btn-primary mat-primary pull-right"
          >
            Clear Filter
          </button>

          <button
            type="submit"
            style="margin-top: 12px; margin-right: 7px"
            (click)="applyFilter()"
            class="btn btn-primary mat-primary pull-right"
          >
            Apply Filter
          </button>

          <!-- <button type="submit"  class="btn btn-primary mat-primary pull-right">Apply Filter </button>  -->
          <!-- <mat-chip-list #chipList aria-label="Filter selection">

          </mat-chip-list> -->
          <mat-chip-list #chipList aria-label="Filter selection">
            <mat-chip
              *ngFor="let filter of matChipArray; let i = index"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(i, filter.tag)"
            >
              {{ filter.name }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>

          <div class="text_filter_data" *ngIf="exportcsvdata">
            <p *ngIf="this.length == 0">
              There's no record found with the given criteria, please try again
              refining your search and filters
            </p>
          </div>
        </div>
      </mat-card>

      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>
          <!-- <ng-container matColumnDef="postedDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Date</mat-header-cell>
            <mat-cell *matCellDef="let GovernmentSchemes">
              {{GovernmentSchemes.postedDate.split(' ')[0]}}
            </mat-cell>
          </ng-container> -->

          <ng-container matColumnDef="postedDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Date
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              {{ newData.postedDate }}
              <!-- {{ formatDate(newData.postedDate) }} -->
            </mat-cell>
          </ng-container>

          <!-- <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Date </mat-header-cell>
              <mat-cell *matCellDef="let newData"> {{newData.date | date: 'dd/MM/yyyy'}}
              </mat-cell>
          </ng-container> -->
          <ng-container matColumnDef="userName">
            <mat-header-cell *matHeaderCellDef mat-sort-header
              >Name
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              <a
                title="View Detail"
                class="userNameCol"
                (click)="openDialog(newData)"
              >
                <div>{{ newData.userName }}</div>
              </a>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="state">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              State
            </mat-header-cell>
            <mat-cell *matCellDef="let newData" class="userNameCol">
              <div>{{ newData.state }}</div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="district">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              District
            </mat-header-cell>
            <mat-cell *matCellDef="let newData" class="userNameCol">
              <div>{{ newData.district }}</div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="sfUserID">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              SF User ID
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              <!-- <mat-icon>grade</mat-icon>&nbsp;&nbsp; -->
              {{ newData.sfUserID }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="sfTicketID">
            <mat-header-cell *matHeaderCellDef mat-sort-header
              >SF Ticket ID</mat-header-cell
            >
            <!-- <mat-cell *matCellDef="let newData" (click)="openTicketDialog(value)">{{newData.sfTicketID}}
            </mat-cell> -->
            <mat-cell *matCellDef="let newData">
              <a
                title="View Detail"
                class="userNameCol"
                (click)="
                  newData.sfTicketID === newData.latestTicketID
                    ? openDialogDetail(newData)
                    : openTicketDialog(newData)
                "
              >
                <div>
                  {{ newData.sfTicketID }}&nbsp;&nbsp;
                  <img
                    src="assets/detail.jpg"
                    *ngIf="newData.sfTicketID === newData.latestTicketID"
                    width="17"
                    height="17"
                  />
                </div>
              </a>
            </mat-cell>
            <!-- <mat-cell *matCellDef="let newData"> {{newData.sfTicketID}}
            </mat-cell> -->
          </ng-container>

          <ng-container matColumnDef="mobileNo">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Mobile No
            </mat-header-cell>
            <mat-cell *matCellDef="let newData">
              {{ newData.mobileNo }}
              <!--<a title="View Profile" class="user_profile" (click)="showDocument(userlist)">-->
              <!--</a>-->
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <div>
          <mat-paginator
            [length]="length"
            [pageIndex]="pageIndex"
            (page)="getServerData($event)"
            [pageSize]="[10]"
            showFirstLastButtons
            aria-label=""
            class="pagination"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="pageEvent">
  <h5>Page Change Event Properties</h5>
  <div>List length: {{ pageEvent.length }}</div>
  <div>Page size: {{ pageEvent.pageSize }}</div>
  <div>Page index: {{ pageEvent.pageIndex }}</div>
</div>

<div class="container-fluid page" *ngIf="Viewprofile">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="showViews()"
    />&nbsp; User Detail
  </div>
  <div class="page__content shadow p-3">
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-1"></div>
        <div class="profile_details">
          <!--class="profile_details"-->
          <mat-card>
            <h5></h5>
            <!-- <p><b>Person Name</b>    : {{personName}}</p>
            <p><b>Phone Number</b>   : {{phoneNo}}</p>
            <p><b>Role</b>           : {{role}}</p>
            <p><b>Mandi</b>          : {{mandi}}</p>
            <p><b>Document Staus</b> : {{documentStatus}}</p>
            <p><b>State</b> : {{states}}</p> -->
            <!-- <div *ngIf="datashowtrader"> -->
            <!---Trader Details -->
            <!-- <p><b>State</b> : {{states}}</p> -->
            <!---Trader Details -->
            <!-- </div> -->
            <!---For farmer -->
            <div
              class="profile_image"
              style="float: right; margin-top: 12px; margin-right: 100px"
            >
              <!-- <h5 style="margin-left: 20px;">Profile Photo</h5> -->
              <!-- <img mat-card-image src="./assets/userImg.png" > -->
              <!-- <img mat-card-image src="{{profile_Image}}" > -->
              <div *ngIf="avtar; else loggedOut">
                <img mat-card-image src="./assets/userImg.png" />
              </div>
              <ng-template #loggedOut>
                <img mat-card-image src="{{ profile_Image }}" />
              </ng-template>
              <div *ngIf="documentStatus == 'Verified'">
                <img
                  src="./assets/verified.png"
                  style="height: 39px; margin-left: 13px"
                />
                <p class="text_verified">
                  <b style="font-size: 18px">Verified</b>
                </p>
              </div>
            </div>

            <div>
              <div *ngIf="datashowfarmer">
                <p><b>Farmer Name</b> : {{ personName }}</p>
                <p><b>Role</b> : {{ role }}</p>
                <p><b>Village</b> : {{ village }}</p>
                <p><b>Taluk</b> : {{ taluk }}</p>
                <p><b>District</b> : {{ district }}</p>
                <p><b>State</b> : {{ states }}</p>
                <p><b>Mobile Number</b> : {{ phoneNo }}</p>
                <!-- <p><b>Mandi</b>          : {{mandi}}</p> -->
                <p><b>No Of Trees</b> : {{ numberOfTrees }}</p>
                <p><b>Types of Trees</b> : {{ treeType }}</p>
                <p><b>Customer Id </b> : {{ treeType }}</p>
              </div>
              <!---For farmer -->
              <!--For Traders -->
              <div *ngIf="datashowtrader">
                <p><b>Trader Name</b> : {{ personName }}</p>
                <p><b>Company </b> : {{ personName }}</p>
                <p><b>Role</b> : {{ role }}</p>
                <p><b>Address</b> : {{ address }}</p>
                <p><b>District</b> : {{ district }}</p>
                <p><b>State</b> : {{ states }}</p>
                <p><b>Mobile Number</b> : {{ phoneNo }}</p>
                <p><b>Email</b> : {{ email }}</p>
                <p><b>Mandi</b> : {{ mandi }}</p>
                <p>
                  <b>Commodity trade interested</b>: {{ commTradeInterest }}
                </p>
                <p><b>Frequency for requirement</b> : {{ reqFrequency }}</p>
                <p><b>About the trader</b> : {{ aboutUs }}</p>
              </div>
            </div>
            <!--For Traders -->
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid page" *ngIf="ViewDetail">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="showViewsDetail()"
    />&nbsp; User Profile
  </div>
  <div class="page__content shadow p-3">
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-1"></div>
        <div class="ticket_details">
          <mat-card>
            <h5></h5>

            <div
              class="profile_image"
              style="float: right; margin-top: 12px; margin-right: 100px"
            >
              <div *ngIf="avtar; else loggedOut">
                <img mat-card-image src="./assets/userImg.png" />
              </div>
              <ng-template #loggedOut>
                <img mat-card-image src="{{ profile_Image }}" />
              </ng-template>
              <div *ngIf="documentStatus == 'Verified'">
                <img
                  src="./assets/verified.png"
                  style="height: 39px; margin-left: 13px"
                />
                <p class="text_verified">
                  <b style="font-size: 18px">Verified</b>
                </p>
              </div>
            </div>

            <div>
              <p><b>Latest Ticket ID</b>: {{ latestTicketID }}</p>
              <p>
                <b>Image List</b>:
                <img [src]="imageList" width="30" height="30" />
              </p>
              <p><b>User Name</b> : {{ userName }}</p>
              <p><b>UserID</b> : {{ userID }}</p>
              <p><b>User Comment</b> : {{ userComment }}</p>
              <p><b>District</b> : {{ district }}</p>
              <p><b>State</b> : {{ state }}</p>
              <p><b>Mobile Number</b> : {{ mobileNo }}</p>
              <p><b>SFUserID</b> : {{ sfUserID }}</p>
              <p><b>SFTicketID</b> : {{ sfTicketID }}</p>
              <p><b>Posted Date </b> : {{ postedDate }}</p>

              <!-- <div *ngIf="datashowtrader">
                <p><b>Trader Name</b> : {{personName}}</p>
                <p><b>Company </b> : {{personName}}</p>
                <p><b>Role</b> : {{role}}</p>
                <p><b>Address</b> : {{address}}</p>
                <p><b>District</b> : {{district}}</p>
                <p><b>State</b> : {{states}}</p>
                <p><b>Mobile Number</b> : {{phoneNo}}</p>
                <p><b>Email</b> : {{email}}</p>
                <p><b>Mandi</b> : {{mandi}}</p>
                <p><b>Commodity trade interested</b>: {{commTradeInterest}}</p>
                <p><b>Frequency for requirement</b> : {{reqFrequency}}</p>
                <p><b>About the trader</b> : {{aboutUs}}</p>
              </div> -->
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
